import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import { MeetingCoPilotFormPresentation } from './_meeting-co-pilot-form/meeting-co-pilot-form.presentation';
import { LOADING_SPINNER_TEXT, LOADING_SPINNER_TIME_TEXT, MEETING_CO_PILOT_MODAL_LABEL } from './meeting-co-pilot.texts';
import './meeting-co-pilot-modal.scss';
import { ModalLoadingScreen } from '../../../shared/modal-loading-screen/modal-loading-screen';
import { MeetingCoPilotModalFooter } from './meeting-co-pilot-modal.footer';
import { CreatedMeetingCoPilotFormPresentation } from './_created-meeting-co-pilot-form/created-meeting-co-pilot-form.presentation';
import { MeetingCoPilotVM } from './meeting-co-pilot.viewmodal';

interface IProps {
    vm: MeetingCoPilotVM;
}

const MeetingCoPilotModal = mobxReact.observer((props: IProps) => {
    const { vm } = props;
    const intl = useIntl();

    if (!vm) return null;

    const showFrom = !vm.isLoading && !vm.isMeetingsDataGenerated;
    const showGeneratedData = !vm.isLoading && vm.isMeetingsDataGenerated;

    return (
        <CommonModal
            className='meeting-co-pilot-modal-wrap'
            title={intl.formatMessage(MEETING_CO_PILOT_MODAL_LABEL)}
            isOpen={vm.isModalOpened}
            onRequestClose={vm.closeModal}
            isExtraWide={showGeneratedData}
            footer={<MeetingCoPilotModalFooter vm={vm}/>}
        >
            {showFrom && <MeetingCoPilotFormPresentation vm={vm} />}
            {vm.isLoading && <ModalLoadingScreen loadingTitle={LOADING_SPINNER_TEXT} loadingInfo={LOADING_SPINNER_TIME_TEXT} />}
            {showGeneratedData && <CreatedMeetingCoPilotFormPresentation vm={vm} />}
        </CommonModal>
    );
});

export { MeetingCoPilotModal };
